// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'
import { SectionOutlet } from '@components/routes/SectionOutlet'

// ** Menu Items Array
import navigation from '@src/navigation/vertical'

const VerticalLayout = (props) => {
  // const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  return (
    <Layout menuData={navigation} {...props}>
      <SectionOutlet />
    </Layout>
  )
}

export default VerticalLayout
